<!--<div class="overlay">-->
<!--  <img src="./assets/images/loader.gif">-->
<!--&lt;!&ndash;    <mat-progress-spinner class="spinner" [color]="color" [mode]="mode" [value]="value">&ndash;&gt;-->
<!--&lt;!&ndash;    </mat-progress-spinner>&ndash;&gt;-->
<!--</div>-->

@if (loading) {
  <div class="overlay">
    <app-rings-loader></app-rings-loader>
  </div>
}
